import Login from "../src/login/Login";

export default function LoginPage(props) {
  return <Login {...props}></Login>;
}
